var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoQ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3643 19.7019C14.5646 19.7019 13.9015 19.0387 13.9015 18.2391V17.8296C13.9015 15.5673 15.5593 14.4556 16.1834 14.0265C16.905 13.5389 17.139 13.2074 17.139 12.7003C17.139 11.7252 16.3394 10.9255 15.3643 10.9255C14.3891 10.9255 13.5895 11.7252 13.5895 12.7003C13.5895 13.4999 12.9264 14.163 12.1268 14.163C11.3272 14.163 10.6641 13.4999 10.6641 12.7003C10.6641 10.1064 12.7703 8 15.3643 8C17.9582 8 20.0644 10.1064 20.0644 12.7003C20.0644 14.9237 18.4263 16.0353 17.8217 16.4449C17.061 16.952 16.827 17.2835 16.827 17.8296V18.2391C16.827 19.0583 16.1639 19.7019 15.3643 19.7019Z",
    fill: "#6E7191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3651 24.5582C14.5459 24.5582 13.9023 23.895 13.9023 23.0954C13.9023 22.2958 14.5654 21.6327 15.3651 21.6327C16.1647 21.6327 16.8278 22.2958 16.8278 23.0954C16.8278 23.895 16.1842 24.5582 15.3651 24.5582Z",
    fill: "#6E7191"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C7.17395 32 0 24.826 0 16C0 7.17395 7.17395 0 16 0C24.826 0 32 7.17395 32 16C32 24.826 24.826 32 16 32ZM16 2.23256C8.4093 2.23256 2.23256 8.4093 2.23256 16C2.23256 23.5907 8.4093 29.7674 16 29.7674C23.5907 29.7674 29.7674 23.5907 29.7674 16C29.7674 8.4093 23.5907 2.23256 16 2.23256Z",
    fill: "#6E7191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoQ);
export default __webpack_public_path__ + "static/media/info-q.1ece3cad74097e1542f65d344c0c9665.svg";
export { ForwardRef as ReactComponent };